import client from "./client";

export const fetchAbout = async () =>{
    const response = await client.get("about")

    return response.data;
};